<template>
<div class="tip">
	<div class="arrow_box message-box">
		<p v-html="stripInlineEventHandlers(message)"></p>
		<button class="btn btn-light float-right" type="button" v-on:click="$emit('close')">
			<i class="fa fa-check"></i>
			Got it
		</button>
		<div style="clear: both;"></div>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "OnboardingTip",
	props: ["message"]
}
</script>

<style scoped>
.tip {
	position: absolute;
}

.message-box {
	padding: 15px;
	font-size: 16pt;
	color: white;
}

.arrow_box {
	position: relative;
	top: 35px;
	background: #28a745;
}
.arrow_box:after {
	bottom: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
	border-color: rgba(43, 111, 213, 0);
	border-bottom-color: #28a745;
	border-width: 30px;
	margin-left: -30px;
}
</style>